<template>
	<ap-button text="Ajouter" @click="redirectAddAnimal" data-cy="add-animal-button"/>
	<div v-if="showDeleteModal" class="modal">
		<div class="modal-content">
			<p>Etes vous sûr de vouloir supprimer cet animal ? </p>
			<div class="modal-buttons">
				<ap-button text="Annuler" name="cancel" type="cancel" @click="showDeleteModal = false" variant="outline" />
				<ap-button text="OK" name="submit" type="submit" @click="deleteSelectedAnimal" variant="danger"/>
			</div>
		</div>
	</div>

	<div v-if = "isLoading">
		<div class="spinner-overlay">
          <div class="spinner"></div>
        </div>
	</div>

	<div v-if="sortedAnimals.length === 0" class="empty-content-container">
		Aucun animal répertorié pour l'instant
	</div>
	<div v-else>
		<div>
			<label>Espèce</label>
			<multiselect v-model="selectedSpecies" :options="species" placeholder="Sélectionner" class="select-species"></multiselect>
		</div>
		<div class="flex">
			<div id="global-worktime" v-if="sortedAnimals.length > 0">
				<h4>Temps de travail <span class="subtitle-form">(en nombre d'heures par numéro de semaine)</span></h4>
				
				<div style="position: sticky; top: 0; max-height: 100vh; overflow: hidden;">
					<Line :data="chartData" :options="chartOptions"  ref="lineChart"/>
				</div>
			</div>
			<div id="animal-list">
				<table class="data-table">
					<thead class="data-table-header">
						<tr>
							<th @click="sort('name')" :class="defineCarretClass('name')">Nom</th>
							<th v-if="!isMobile" @click="sort('nbWorkingHoursByWeek')" :class="defineCarretClass('nbWorkingHoursByWeek')">Nb heures prévues</th>
						</tr>
					</thead>
					<tbody v-if="sortedAnimals.length > 0">
						<tr
							v-for="(animal, index) in sortedAnimals"
							v-bind:key="index"
							@mouseover="handleMouseEnter(index)"
							@mouseleave="handleMouseLeave"
							@click="redirectEditAnimal(animal.id)" 
						>
							<td>{{ animal.name }}</td>
							<td v-if="!isMobile" style="width:15%">{{ animal.nbWorkingHoursByWeek }}</td>
							<td v-if="!isMobile" class="data-table-edit"> 
								<div v-if="hoveredAnimalIndex === index" class="update-item">
									<font-awesome-icon icon="pen" class="data-table-edit-icon"/>
									<font-awesome-icon icon="trash-alt" @click.stop="displayDeleteModal(animal.id)" class="data-table-edit-icon"/>	
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	

</template>
<script>
import { mapState } from 'vuex';
import { Line } from 'vue-chartjs';
import { Chart, registerables } from "chart.js";
import ApButton from '../../commons/APButton';

Chart.register(...registerables);

export default {
	// eslint-disable-next-line
	name: 'Animals',
	components: {
		Line,
		ApButton
	},
	data() {
		return {
			showDeleteModal: false,
			hoveredAnimalIndex: null,
			currentSort:'name',
			currentSortDir:'asc',
			chartAPData: {},
			chartOptions: {
				plugins: {
					legend: {
						display: true
					}
				},
			},
			isMobile: this.$store.state.isMobile,
			species: [],
			selectedSpecies: null,
			sortedAnimals: [],
			animalsColors: new Map(),
			isLoading: false

		};
	},
	methods: {
		handleMouseEnter(index) {
			this.hoveredAnimalIndex = index;
		},
        handleMouseLeave() {
            this.hoveredAnimalIndex = null;
		},
		sort(s) {		
			if(s === this.currentSort) {
				this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
			}
			this.currentSort = s;
		},
		defineCarretClass(criteria) {
			if (criteria === this.currentSort) {
				if (this.currentSortDir === 'asc')
					return 'carret-up';

				return 'carret-down';
			}
			return '';
		},
		getLabelsFromActivities() {

			var filteredAnimals = this.animals
			if (this.selectedSpecies !== 'Toutes' && this.selectedSpecies !== null) {
				filteredAnimals = this.animals.filter(a => a.type !== null && a.type.species === this.selectedSpecies);
			}

			let output = [];
			let infosByWeek = filteredAnimals.map(a => [a.name, a.infosByWeek]);
			for (var i=0; i < infosByWeek.length ; ++i) {
				for(var j = 0; j < infosByWeek[i][1].length; j++)
					output.push(infosByWeek[i][1][j].weekNumber+'-'+ infosByWeek[i][1][j].year);
			}

			output.sort((a, b) => {
				let yearMonthA = a.split('-');
				let yearMonthB = b.split('-');
				if (yearMonthA[1] < yearMonthB[1]) {
					return -1;
				} else if (yearMonthA[1] === yearMonthB[1]) {
				return parseInt(yearMonthA[0]) < parseInt(yearMonthB[0]) ? -1:1;
				} else {
				return 1;
				}
			});
			output = [...new Set(output)];
			return output;
		},
		getDataFromActivities(labels) {
			var filteredAnimals = this.animals
			if (this.selectedSpecies !== 'Toutes' && this.selectedSpecies !== null) {
				filteredAnimals = this.animals.filter(a => a.type !== null && a.type.species === this.selectedSpecies);
			}

			let infosByWeek = filteredAnimals.map((a) => {
									let data = [];

									for (let i = 0; i < labels.length; i++) {
										let found = false;
										for (let j = 0; j < a.infosByWeek.length; j++) {
											let searchingWeek = a.infosByWeek[j].weekNumber+'-'+a.infosByWeek[j].year;
											if (labels[i] === searchingWeek) {
												data.push(a.infosByWeek[j].nbHours);
												found = true;
												break;
											}
										}
										if (!found) {
											data.push(0);
										}
									}

									return {
										label: a.name, 
										data: data,
										fill: true,
										backgroundColor: [this.animalsColors.get(a.id)],
										borderColor: [this.animalsColors.get(a.id)]
									}
								});
			return infosByWeek;
		},
		sendInitAnimals() {
			this.isLoading = true;
			this.$store.dispatch('initAnimals')
			.catch(response => {
                if (response.status === 401) {
                    this.$store.dispatch('logout');
					this.$router.push('/');
				}
            }).finally(() => {
				this.isLoading = false;
			});
		},
		redirectAddAnimal() {
			this.$router.push({name: 'CreateAnimal'})
		},
		redirectEditAnimal(animalId) {
			this.$router.push({name: 'EditAnimal', params: { id : animalId }})
		},
        displayDeleteModal(animalId) {
            this.animalId = animalId;
            this.showDeleteModal = true;
        },
		deleteSelectedAnimal() {
			this.$store.dispatch({
				type: 'deleteAnimal',
				id: this.animalId,
			}).then(() => {
				this.$toast.success(`Animal correctement supprimé`);
			}).catch((error) => {
				if (error.response.data.errorCode === 'E106') {
					this.$toast.error(`Animal déjà supprimé`);
					this.$router.push('/pros/animals');
				} else {
					this.$toast.error(`Erreur lors de la suppression de l'animal`);
				}
			});
			this.showDeleteModal = false;
		},
		sortAnimals() {
			this.sortedAnimals = this.$store.state.animals.sort((a,b) => {
				let modifier = 1;
				if(this.currentSortDir === 'desc') modifier = -1;
				if (this.currentSort === 'club') {
					if(a.club.name < b.club.name) return -1 * modifier;
					if(a.club.name > b.club.name) return 1 * modifier;
				} else {
					if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
				}
				return 0;
			}).filter(a => {
				if (this.selectedSpecies === 'Toutes' || this.selectedSpecies === null) {
					return true;
				}
				return a.type !== null && a.type.species === this.selectedSpecies;
			});
		},
		getRandomColor() {
			const letters = '0123456789ABCDEF';
			let color = '#';
			for (let i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
	},
	computed: {
		...mapState(['animals', 'clubs']),
		chartData() {
			this.sortAnimals();
			let labels = this.getLabelsFromActivities()

			var filteredAnimals = this.animals
			if (this.selectedSpecies !== 'Toutes' && this.selectedSpecies !== null) {
				filteredAnimals = this.animals.filter(a => a.type !== null && a.type.species === this.selectedSpecies);
			}

			let infosByWeek = filteredAnimals.map((a, index) => {
						let data = [];

						let color = this.hoveredAnimalIndex !== null && this.hoveredAnimalIndex !== index 
                                ? this.animalsColors.get(a.id) + '40' 
                                : this.animalsColors.get(a.id)
								
						for (let i = 0; i < labels.length; i++) {
							let found = false;
							for (let j = 0; j < a.infosByWeek.length; j++) {
								let searchingWeek = a.infosByWeek[j].weekNumber+'-'+a.infosByWeek[j].year;
								if (labels[i] === searchingWeek) {
									data.push(a.infosByWeek[j].nbHours);
									found = true;
									break;
								}
							}
							if (!found) {
								data.push(0);
							}
						}

						return {
							label: a.name, 
							data: data,
							fill: true,
							backgroundColor: [color],
							borderColor: [color],
							borderWidth: this.hoveredAnimalIndex === index ? 4 : 2,
                            pointRadius: this.hoveredAnimalIndex === index ? 6 : 3,
                            pointHoverRadius: 8,
						}
					});

			return {
				labels: labels,
				datasets: infosByWeek,
			}
		}	
	},
	watch: {
		animals(newVal) {
			this.species = [...new Set(newVal.map(a => a.type?.species).filter(s => s !== undefined))];
			this.species.unshift('Toutes');
			this.sortAnimals();
			this.$store.state.animals.forEach(element => {
				this.animalsColors.set(element.id, this.getRandomColor());
			});
		}
	},
	mounted() {
		this.sendInitAnimals();
	},
};
</script>

<style scoped>
.select-species {
	width: 20%;
	margin-bottom: 1rem;
}
#global-worktime {
	margin: 2rem auto 0 auto;
	flex: 7;
}
#animal-list {
	flex: 3;
}

.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255,255,255,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }

.spinner {
  width: 48px;
  height: 48px;
  border: 10px solid var(--anima-primary-color);
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation-spinner 1s linear infinite;
}

@keyframes rotation-spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>